import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {TaskMessageStatus} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-task-message-status',
    templateUrl: './task-message-status.component.html',
    styleUrls: ['./task-message-status.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskMessageStatusComponent {
  messageStatus = input<TaskMessageStatus>();
  label = input<string>();
  reason = input<string>();
  customLabel = input<string>();
  header = input<string>();
  showTooltip = input(true);
  sentenceCasePipe = input(true);
  customCssClass = input<string>();

  messageStatusLabel = computed(() => {
    if (this.customLabel()) {
      return this.customLabel();
    }
    switch (this.messageStatus()) {
      case TaskMessageStatus.UNKNOWN: return "Nothing filled in";
      case TaskMessageStatus.SAVED: return "(Partly) filled but not sent";
      case TaskMessageStatus.SCHEDULED: return "Scheduled";
      case TaskMessageStatus.DEADLINE_CLOSE: return "Deadline close, X left";
      case TaskMessageStatus.DEADLINE_MISSED: return "Deadline missed";
      case TaskMessageStatus.PENDING: return "Pending";
      case TaskMessageStatus.DELIVERED: return "Received";
      case TaskMessageStatus.ACCEPTED: return "Approved";
      case TaskMessageStatus.ACCEPTED_WITH_CONDITIONS: return "Accepted with conditions";
      case TaskMessageStatus.WARNING: return this.reason() || "Rescheduled";
      case TaskMessageStatus.ERROR: return this.reason() || "Error";
      case TaskMessageStatus.REJECTED: return "Rejected";
    }
  });
}
